import React, { useCallback, useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import PhoneInput from "react-phone-input-2";
import { GoogleReCaptcha } from "react-google-recaptcha-v3";
import { addusermobile } from "../../../Store/Auth/actions";
import { isValidPhoneNumber } from "libphonenumber-js";
import "../Login/Login.scss";
import "react-phone-input-2/lib/bootstrap.css";
import "react-phone-input-2/lib/material.css";

export default function Addnumber(props) {
  const [value, setValue] = useState();
  const [isLoading, setIsLoading] = useState(false);
  const userid = useSelector((state) => state.Auth?.registersuccessId);
  const dispatch = useDispatch();
  const history = useHistory();
  const [authToken, setAuthToken] = useState("");
  const [isValid, setIsValid] = useState(false);
  let business = useSelector((state) => state.Business?.data);
  const addnumber = () => {
    dispatch(
      addusermobile({
        id: userid,
        mobileNumber: value,
        type: 1,
        modifiedBy: userid,
        setIsLoading,
      })
    );
  };
  const handleToken = (token) => {
    setIsLoading(true);
    setAuthToken(token);
    setIsLoading(false);
    return token;
  };

  const handlePhoneNumberChange = (phoneNumber, country) => {
    setValue(phoneNumber);
    const isValidNumber = isValidPhoneNumber(phoneNumber, country);
    setIsValid(isValidNumber);
  };

  return (
    <div className="login_height">
      {!authToken && <GoogleReCaptcha onVerify={handleToken} />}
      {/* <div>
        {business?.length > 0 ? (
          <a
            href="/buzzcom"
            style={{
              position: "absolute",
              top: "30px",
              right: "50px",
            }}
            className="skip-button"
          >
            Skip
          </a>
        ) : (
          <a
            href="/dashboard"
            style={{
              position: "absolute",
              top: "30px",
              right: "50px",
            }}
            className="skip-button"
          >
            Skip
          </a>
        )}
      </div> */}
      <div className="container mb-5 pb-5">
        <div className="container paddings">
          <div className="pt-5 mt-5text-center alignment_vertically">
            <div className="pb-3">
              <img
                className="img-fluid img_plexar_width"
                src="../images/plexaar final 2 round-15 1.png"
                alt="no-data"
                style={{ width: "100px", height: "100px" }}
              />
              <div>
                <img
                  className="img-fluid img_plexar_width"
                  src="../images/plexaar text-22 1.png"
                  alt="no-data"
                  style={{ width: "111px", height: "46" }}
                />
              </div>
            </div>
            <h3>
              <b>
                Profile <span className="plexar_font">Information</span>
              </b>
            </h3>
            <p className="sub_heading mb-0 text-wrap">
              Dear user please add your personal information to complete
              Registration
            </p>
            <div className="pt-3">
              <div className="ps-2 pt-4">
                <PhoneInput
                  //  inputStyle={{color:'green'}}
                  //  containerStyle={{backgroundColor:"#000"}}
                  buttonStyle={{ borderRight: "1px solid #DCDCDC" }}
                  //  dropdownStyle={{height:'50px'}}
                  inputStyle={{
                    width: "97%",
                    height: "46px",
                    color: " #616161",
                    border: "1px solid #DCDCDC",
                    borderRadius: "8px",
                    paddingLeft: "70px",
                    // paddingRight: "40px",
                    transition:
                      "background-color 0.3s, color 0.3s, border-color 0.3s",
                  }}
                  country={"pk"}
                  inputProps={{
                    onFocus: (e) => {
                      e.target.style.backgroundColor = "white";
                    },
                    onBlur: (e) => {
                      e.target.style.backgroundColor = "";
                    },
                  }}
                  value={value}
                  onChange={(phoneNumber, country) =>
                    handlePhoneNumberChange(phoneNumber, country)
                  }
                  // className="phone-input"
                />
              </div>
              <div className="pb-4 px-0 pt-1">
                <button
                  className={`btn btn-primary ${
                    value === undefined || value?.length <= 7
                      ? "button_width_disabled"
                      : "button_width"
                  } btn-lg`}
                  onClick={addnumber}
                  disabled={value === undefined || value?.length <= 7 }
                  // disabled={authToken ? false : true&& value===""}
                  // onClick={() =>
                  //   history.push(`/verify-number/${value}`)
                  // }
                >
                  {isLoading ? (
                    <div className="spinner-border text-light" role="status">
                      <span className="sr-only">Loading...</span>
                    </div>
                  ) : (
                    <>Confirm</>
                  )}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="bottom_attach px-3 pt-2 center_copyright">
        <div className="show_privacy_policy">
          <p
            className="sub_heading2"
            role="button"
            onClick={() => history.push("/privacy")}
          >
            Privacy Policy
          </p>{" "}
          &nbsp; &nbsp; &nbsp;
          <p
            className="sub_heading2"
            role="button"
            onClick={() => history.push("/terms")}
          >
            Terms & Conditions
          </p>
        </div>
        <p className="sub_heading2">
          Copyright © 2023 Plexaar. All rights reserved.
        </p>
      </div>
    </div>
  );
}
